import { useQuery } from '@tanstack/react-query';
import { getSalesOrgs } from '../providers/productFinderAPI';
import { queryKeys } from './queryKeys';
import ISalesOrg from '../models/iSalesOrg';

export const useSalesOrgs = (bearerToken: string, enabled = true) => {
  return useQuery<ISalesOrg[]>({
    queryKey: queryKeys.salesOrgs(),
    queryFn: () => getSalesOrgs(bearerToken),
    enabled: enabled && !!bearerToken,
  });
};
